let dragDoneTimer = null;
let pointerDown = false;
document.addEventListener('pointerdown', () => pointerDown = true);
document.addEventListener('pointerup', () => pointerDown = false);
document.addEventListener('pointercancel', () => pointerDown = false);
let hoverTimer;

$(document).ready(function(){
  
    setupFilterSliders()
    
}).on('FILTERS_UPDATE', function(){
    setupFilterSliders()
}).on('click',  function(e){
    if(!$(e.target).closest('[data-products-menu-container]').length && !$(e.target).closest('[data-search-menu-container]').length && !$(e.target).closest('a[href="#products-menu"]').length && !$(e.target).closest('a[href="#search-menu"]').length && !$(e.target).is('a[href="#products-menu"]') && !$(e.target).is('a[href="#search-menu"]')){
        $('[data-search-menu-container]').addClass('h-0');
        $('[data-products-menu-container]').addClass('h-0');
    }
}).on('click', '[data-search-tab]', function(){
    let tab = $(this).data('search-tab');
    $(this).addClass('g-megamenu-selected').siblings().removeClass('g-megamenu-selected')
    $('[data-search-menu="'+tab+'"]').removeClass('h-0 overflow-hidden').siblings().addClass('h-0 overflow-hidden')
}).on('mouseenter', 'a.header__menu-item[href="/collections/all"]', function(e){
    e.preventDefault()

        // Start a short delay before opening
    hoverTimer = setTimeout(() => {
        $('[data-search-menu-container]').addClass('h-0');
        $('[data-products-menu-container]').toggleClass('h-0');
    }, 150); // adjust delay (ms) to taste
    
}).on('mouseleave', 'a.header__menu-item[href="/collections/all"]', function() {
    clearTimeout(hoverTimer); // cancel if they passed quickly
}).on('mouseleave', '[data-products-menu-container]', function(e){
    e.preventDefault()
    $('[data-products-menu-container]').addClass('h-0');
    
}).on('click', 'a[href="#search-menu"]', function(e){
    e.preventDefault()
    $('[data-products-menu-container]').addClass('h-0');
    $('[data-search-menu-container]').toggleClass('h-0');
}).on('change', '[data-addon-toggle]', function(e){
    // document.querySelector('[data-addon-wrapper]').classList.toggle('invisible')
    // document.querySelector('[data-addons-list]').classList.toggle('invisible')
}).on('change', '[data-search-menu] [data-image]', function(e){
    let image = $(this).data('image');
    let $img  = $(this).closest('[data-search-menu]').find('[data-search-image]');
    let full = $img.data('search-image');

    if(image && $img.length){
        if(full == 'full'){
            $img.html('<img class="w-full h-full object-cover" src="'+image+'"/>')
        }else{
            $img.html('<img src="'+image+'"/>')
        }
        
    }
})

function steppedRange(a, b, step = 100) {
    if (step === 0 || !Number.isFinite(step)) {
      throw new Error('step must be a non-zero finite number');
    }
  
    // Work with a positive step internally
    const gap   = Math.abs(step);
    const start = Math.min(a, b);
    const end   = Math.max(a, b);
    const out   = [];
  
    // First value aligned to the nearest multiple of `gap` ≥ start
    let current = Math.ceil(start / gap) * gap;
  
    while (current <= end) {
      out.push(current);
      current += gap;
    }
  
    // Preserve the caller’s original direction
    return a <= b ? out : out.reverse();
}

function setupFilterSliders(){
    let filterSliders = $('[data-filter-menu]')


    filterSliders.each(function(){
        let $filter = $(this);
        let $slider = $filter.find('[data-filter-menu-slider]');
        let $start = $filter.find('[data-filter-menu-start]');
        let $end = $filter.find('[data-filter-menu-end]');
        let $checkboxes = $filter.find('input[type=checkbox]');
        let filter_param = $filter.data('filter-param')
        let $selected_values_inputs = $filter.find('[data-selected-values-inputs]')
        
        if($slider){
            let values_html = $filter.find('[data-values]');
            if(!values_html.length) return
            try {
                let values = JSON.parse(values_html.html());
                if(!values) return;
                let active_values_html = $filter.find('[data-active-values]');
                let active_values = active_values_html.length ? JSON.parse(active_values_html.html()) : [];
                if(values){
                    let start = values.findIndex(v => {
                        return v == active_values[0];
                    })
                    
                    let end = values.findIndex(v => {
                        return v == active_values[active_values.length - 1];
                    })

                    if(active_values.length){
                        console.log(active_values)
                    }

                    if($start.length){
                        $slider.dxRangeSlider({
                            min: 0,
                            max: values.length - 1,
                            start: start > -1 ? start : 0,
                            end: end > -1 ? end : values.length - 1,
                            rtlEnabled: false,
                            tooltip: {
                                enabled: true,
                                format(value) {
                                    return values[value].replace(/&quot;/g, '"');
                                },
                                showMode: 'onHover',
                                position: 'top',
                            },
                            valueChangeMode: 'onHandleRelease',
                            onValueChanged : function(component){
                            
                                $start.html(values[component.start])
                                $end.html(values[component.end])
                                
                                const selectedValues = values.slice(component.start, component.end + 1);
                                if(!$selected_values_inputs.length){
                                    values.forEach(v => {
                                        v = v.replace(/&quot;/g, '"')
                                        let match = $checkboxes.filter(function() {
                                            return this.value === v;
                                        });
                                        if(match.length){
                                            match.prop('checked', false);
                                        }else{
                                            console.log(v)
                                        }
                                    })
                                    selectedValues.forEach(v => {
                                        v = v.replace(/&quot;/g, '\"')
                                        let match = $checkboxes.filter(function() {
                                            return this.value === v;
                                        });
                                        if(match.length){
                                            match.prop('checked', true);
                                        }else{
                                            console.log(v)
                                        }
                                    })
                                    $('#FacetFiltersForm')[0].dispatchEvent(new Event('input', { bubbles: true }));
                                }else{
                                    $selected_values_inputs.html('')
                                    selectedValues.forEach(v => {
                                        
                                        $selected_values_inputs.append('<input type="hidden" name="'+filter_param+'" value="'+v.replace(/"/g, '&quot;')+'"/>')
                                    })
                                }
                            }
                        });
                    }else{
                        $slider.dxSlider({
                            min: 0,
                            max: values.length - 1,
                            value: end > -1 ? end : values.length - 1,
                            rtlEnabled: false,
                            tooltip: {
                                enabled: true,
                                format(value) {
                                    return values[value].replace(/&quot;/g, '"');
                                },
                                showMode: 'onHover',
                                position: 'top',
                            },
                            valueChangeMode: 'onHandleRelease',
                            onValueChanged : function(component){
                            
                                $end.html(values[component.value]);
                                
                                const selectedValues = values.slice(0, component.value + 1);
                                if(!$selected_values_inputs.length){
                                    values.forEach(v => {
                                        v = v.replace(/&quot;/g, '"')
                                        let match = $checkboxes.filter(function() {
                                            return this.value === v;
                                        });
                                        if(match.length){
                                            match.prop('checked', false);
                                        }else{
                                            console.log(v)
                                        }
                                    })
                                    selectedValues.forEach(v => {
                                        v = v.replace(/&quot;/g, '\"')
                                        let match = $checkboxes.filter(function() {
                                            return this.value === v;
                                        });
                                        if(match.length){
                                            match.prop('checked', true);
                                        }else{
                                            console.log(v)
                                        }
                                    })
                                    $('#FacetFiltersForm')[0].dispatchEvent(new Event('input', { bubbles: true }));
                                }else{
                                    $selected_values_inputs.html('')
                                    selectedValues.forEach(v => {
                                        
                                        $selected_values_inputs.append('<input type="hidden" name="'+filter_param+'" value="'+v.replace(/"/g, '&quot;')+'"/>')
                                    })
                                }
                            }
                        });
                    }
                }
            } catch (error) {
                console.log(values_html.html())
            }
        }
    })


    const categoryParams = new URLSearchParams(location.search);
    categoryParams.delete('page');
    document.querySelectorAll('[data-fake-filter-link]').forEach(function(link){
        const url = new URL(link.href);
        url.search = categoryParams.toString();
        link.href = url.toString();
    })
}


(function () {
  // ---- tiny preloader (off-DOM) ----
  function preload(urls, { concurrency = 3 } = {}) {
    const conn = navigator.connection || {};
    if (conn.saveData || /2g/i.test(conn.effectiveType || '')) return Promise.resolve([]);

    return new Promise((resolve) => {
      let i = 0, active = 0, done = 0, out = [];
      function next() {
        if (done === urls.length) return resolve(out);
        while (active < concurrency && i < urls.length) {
          const url = urls[i++];
          active++;
          const img = new Image();
          img.decoding = 'async';
          try { img.fetchPriority = 'low'; } catch {}
          img.onload = img.onerror = () => { active--; done++; out.push(url); next(); };
          img.src = url; // starts the request without touching the DOM
        }
      }
      next();
    });
  }

  // ---- collect data-image urls (dedup, trim) ----
  function collectDataImageUrls(selector = '[data-search-menu] [data-image]') {
    const els = Array.from(document.querySelectorAll(selector));
    const urls = els.flatMap(el =>
      String(el.getAttribute('data-image') || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
    );
    // absolute-ize relative URLs to avoid cache misses from different bases
    const toAbs = (u) => {
      try { return new URL(u, location.href).href; } catch { return u; }
    };
    return Array.from(new Set(urls.map(toAbs)));
  }

  // ---- kick off AFTER initial load ----
  function onLoad(cb){ 
    if (document.readyState === 'complete') cb();
    else addEventListener('load', cb, { once: true });
  }

  onLoad(() => {
    const urls = collectDataImageUrls();
    if (urls.length) preload(urls, { concurrency: 2 });
  });

  // (Optional) helper to apply later when you inject:
  //   el.style.backgroundImage = `url("${url}")`;
  //   or for <img>: img.src = url;
})();
